// Permission to edit the quotation Included / Excluded mentions (FD-4602).
// A network (network, sub-network, mini-network) allows or disallows it;
// an organisation can also inherit the value from its network.
export type NetworkQuotationIncludedPermission = 'allow' | 'disallow';
export type ClientQuotationIncludedPermission = NetworkQuotationIncludedPermission | 'inherit';

export const DEFAULT_NETWORK_QUOTATION_INCLUDED_PERMISSION: NetworkQuotationIncludedPermission = 'disallow';
export const DEFAULT_CLIENT_QUOTATION_INCLUDED_PERMISSION: ClientQuotationIncludedPermission = 'inherit';

// Anything carrying a network-level permission (network, sub-network, mini-network as nested on an organisation).
export interface QuotationIncludedPermissionHolder {
    can_edit_quotation_included?: NetworkQuotationIncludedPermission | null;
}
